import React, { useState, useEffect } from 'react';

const SportImage = ({
    src,
    fallbackSrc,
    alt = '',
    className,
    style,
    width,
    height,
}) => {
    // Resolve dynamic path prefixes to prevent proxy assets loading failure
    const getDynamicFallback = (fallback) => {
        if (!fallback) return '';
        // We import PAGES_API_HOST / API_HOST from config, but since we want to avoid hardcoding,
        // we can dynamically build the URL or use the window location origin
        if (typeof window !== 'undefined') {
            const hostname = window.location.hostname;
            // If running on local, use local path.
            if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
                return fallback;
            }
            // In staging and production, return the current origin prefix so it fetches from the active app host domain
            return `${window.location.origin}${fallback}`;
        }
        return fallback;
    };

    const resolvedFallback = getDynamicFallback(fallbackSrc);
    const isValidSrc = src && typeof src === 'string' && src.trim().length > 5;
    const [imgSrc, setImgSrc] = useState(isValidSrc ? src : resolvedFallback);

    useEffect(() => {
        const isValid = src && typeof src === 'string' && src.trim().length > 5;
        setImgSrc(isValid ? src : resolvedFallback);
    }, [src, resolvedFallback]);

    return (
        <img
            src={imgSrc}
            alt={alt}
            className={className}
            style={style}
            width={width}
            height={height}
            onError={() => {
                if (imgSrc !== resolvedFallback) {
                    setImgSrc(resolvedFallback);
                }
            }}
        />
    );
};

export default SportImage;
